<template>
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>HomeIcon</title>
    <g
      id="home-icon"
      class="override-fill"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <!-- eslint-disable max-len -->
      <path
        id="Combined-Shape"
        d="M8.75,13.4166667 L8.75,8.75 L5.25,8.75 L5.25,13.4166667 L1.16666667,13.4166667 L1.16666667,4.66524769 L7.014,0.748628568 L12.8333333,4.66524769 L12.8333333,13.4166667 L8.75,13.4166667 Z"
        class="override-stroke"
        stroke="none"
        fill-rule="nonzero"/>
        <!-- eslint-enable max-len -->
    </g>
  </svg>
</template>

<script>
export default {
  name: 'HomeIcon',
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/icons/HomeIcon.vue